import React from 'react';
import { motion } from 'framer-motion';
import { Code, GraduationCap, Calendar, Award } from 'lucide-react';

const Formation = ({ formation }) => {
  return (
    <section className="py-20 section-spacing">
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
        className="bg-gradient-to-br from-dark-surface to-dark-card rounded-xl p-8 border border-violet-500/20 relative overflow-hidden"
      >
        
        {/* Décoration */}
        <div className="absolute -right-10 -top-10 w-40 h-40 bg-violet-600/10 rounded-full blur-3xl" />

        
        
        <div className="relative z-10">
          <div className="flex items-center gap-3 mb-6">
            <div className="bg-violet-600/20 p-3 rounded-full">
              <GraduationCap className="text-violet-400" size={28} />
            </div>
            <div>
              <h2 className="text-3xl md:text-4xl font-bold gradient-text mb-1">Formation</h2>
              <div className="text-xs font-mono text-gray-500">$ echo $EDUCATION</div>
            </div>
          </div>

          <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
            <div>
              <h3 className="text-2xl font-bold text-white mb-2">{formation.school}</h3>
              <p className="text-gray-300 text-lg flex items-center gap-2">
                <Award size={18} className="text-violet-400" />
                {formation.title}
              </p>
            </div>
            <div className="flex items-center gap-2 text-gray-400 font-mono text-sm bg-dark-bg/50 px-4 py-2 rounded-full border border-dark-border">
              <Calendar size={14} className="text-violet-400" />
              <span>{formation.period}</span>
            </div>
          </div>

          {/* Badge supplémentaire */}
          <div className="mt-6 flex gap-2">
            <span className="px-3 py-1 bg-green-900/20 text-green-400 rounded-full text-xs font-mono border border-green-700/30">
              Bac+5
            </span>
            <span className="px-3 py-1 bg-blue-900/20 text-blue-400 rounded-full text-xs font-mono border border-blue-700/30">
              Architecte logiciel
            </span>
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default Formation;